import React from 'react';
export const LineHorizontal = () => (React.createElement("div", { className: 'line line-horizontal' },
    React.createElement("span", null),
    React.createElement("span", null)));
